import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import Link from '@atlaskit/link';
import { token } from '@atlaskit/tokens';

import { SignupBackgroundLayout } from '@/components/signup/layouts/signup-background-layout';
import { RovoDevAgentsLogo } from '@/components/signup/utils/logos/rovo-dev-agents-logo';
import { useLocalizedHref } from '@/libraries/web-framework/src/localization/use-localized-href';

/**
 * Rendered in place of the Rovo Dev signup form when the `kill-rovo-dev-signup`
 * feature gate is enabled. This is an in-page message rather than a redirect, so
 * anyone landing on the signup page keeps their URL and is pointed at sales.
 */
export const RovoDevSignupUnavailable = (): JSX.Element => {
	const contactSalesHref = useLocalizedHref('/enterprise/contact');

	return (
		<SignupBackgroundLayout ProductLogo={<RovoDevAgentsLogo />}>
			<div css={containerCss} data-testid="rovo-dev-signup-unavailable">
				<h1 css={headingCss}>
					<FormattedMessage
						id="signup-page.rovo-dev-signup-unavailable.heading"
						defaultMessage="Rovo Dev sign-up is no longer available"
					/>
				</h1>
				<p css={bodyCss}>
					<FormattedMessage
						id="signup-page.rovo-dev-signup-unavailable.body"
						defaultMessage="You can no longer sign up for Rovo Dev here. Get in touch with our sales team to talk through your options."
					/>
				</p>
				<p css={bodyCss}>
					<Link href={contactSalesHref}>
						<FormattedMessage
							id="signup-page.rovo-dev-signup-unavailable.contact-sales-link"
							defaultMessage="Contact sales"
						/>
					</Link>
				</p>
			</div>
		</SignupBackgroundLayout>
	);
};

const containerCss = css({
	display: 'flex',
	flexDirection: 'column',
	gap: token('space.100'),
	textAlign: 'center',
});

const headingCss = css({
	margin: 0,
	fontSize: 20,
	fontWeight: 600,
});

const bodyCss = css({
	margin: 0,
});
